import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../service/main.service';
import { Router } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';
import { MustMatch } from '../../service/must-match.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss'
})
export class SignUpComponent {
  signUp: any = FormGroup;
  submitted: boolean = false;
  showPassword: boolean = false;
  confirmPassword: boolean = false;
  constructor(
    private location: Location,
    private fb: FormBuilder,
    private router: Router,
    private toasterService: ToasterServiceService) {
    this.signUp = this.fb.group({
      userName: ['', [Validators.required,Validators.pattern('^[a-zA-Z \-\']+')]],
      contact_no: ['', [Validators.required,Validators.pattern("^[0-9]*$"),Validators.minLength(7)]],
      password: ['', [Validators.required]],
      cpassword: ['', [Validators.required]]
    }, {
      validator: MustMatch('password', 'cpassword')
    });
  }

  goBackToPrevPage() {
    this.location.back();
  }

  get f() {
    return this.signUp.controls;
  }

  password() {
    this.showPassword = !this.showPassword
  }

  goToLogin() {
    this.submitted = true;
    if (this.signUp.valid) {
    this.toasterService.toastSuccess('સાઇન અપ સફળતાપૂર્વક પૂર્ણ થયું')
    this.router.navigate(['/auth/login']);
    }
  }

  confirmPwd() {
      this.confirmPassword = !this.confirmPassword;
  }
}
